import api from "./api.ts";

// Fetch scores for a user
export async function getScores() {
  const token = localStorage.getItem("token");
  return api.get("/scores", {
    headers: token ? { Authorization: `Bearer ${token}` } : {}
  });
}

export async function saveScore(request: any) {
  const token = localStorage.getItem("token");
  return api.post(
    "/scores/set_score",
    { request },
    { headers: token ? { Authorization: `Bearer ${token}` } : {} }
  );
}
